import React from 'react';
import { useSelector } from 'react-redux';
import WorkspaceList from './WorkspaceList';
import withInfiniteScroll from '../InfiniteScroll/withInfiniteScroll';

const index = (props) => {
  const { enableInfiniteScroll = false } = props;

  // Fetch data using useSelector
  const workspaceList = useSelector((state) => state.organization?.workspaceList);

  // If infinite scroll is not enabled, just render the component with all data
  if (!enableInfiniteScroll) {
    return <WorkspaceList data={workspaceList} {...props} />;
  }

  // Otherwise wrap with infinite scroll HOC
  return withInfiniteScroll(WorkspaceList, {
    initialLoadCount: 20,
    fetchOnScroll: true,
    maxHeight: 'calc(100vh - 220px)',
    mode: 'local',
  })({ data: workspaceList, ...props });
};

export default index;
